/* Honey Feast simple one-click product pair add-on. Draft Eurus integration. */
(function(){
  document.addEventListener('click', async function(event){
    const button = event.target.closest('[data-hf-quick-add]');
    if(!button || button.disabled)return;
    const root=button.closest('[data-hf-pairs]');
    if(!root)return;
    const id=Number(button.getAttribute('data-hf-variant'));
    if(!Number.isSafeInteger(id)||id<=0)return;
    const status=root.querySelector('[data-hf-pairs-status]');
    const original=button.textContent;
    button.disabled=true;
    button.textContent='Adding…';
    if(status)status.hidden=true;
    try{
      const alpine=window.Alpine;
      const helper=alpine&&alpine.store('xCartHelper');
      const sections=helper&&helper.getSectionsToRender?helper.getSectionsToRender():[];
      const body={id:id,quantity:1};
      if(sections.length){body.sections=sections.map(s=>s.id);body.sections_url=window.location.pathname;}
      const shopRoot=window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/';
      const response=await fetch(shopRoot+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(body)
      });
      const added=await response.json();
      if(!response.ok)throw new Error(added.description||'Item could not be added.');
      if(added.sections){
        sections.forEach(function(section){
          const html=added.sections[section.id];
          const destination=document.querySelector(section.selector);
          if(!html||!destination)return;
          const updated=new DOMParser().parseFromString(html,'text/html').querySelector(section.selector);
          if(updated)destination.innerHTML=updated.innerHTML;
        });
      }
      if(helper){
        const count=document.querySelector('#cart-icon-bubble span');
        if(count)helper.currentItemCount=parseInt(count.textContent,10)||0;
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      const notify=alpine&&alpine.store('xCartNoti');
      const drawer=alpine&&alpine.store('xMiniCart');
      if(notify&&notify.enable&&typeof notify.setItem==='function')notify.setItem(added);
      else if(drawer&&typeof drawer.openCart==='function')drawer.openCart();
      button.textContent='Added ✓';
      if(status){status.textContent='Added to cart.';status.hidden=false;}
    }catch(error){
      button.textContent=original;
      if(status){status.textContent=error&&error.message?error.message:'Please try again.';status.hidden=false;}
    }finally{button.disabled=false;}
  });
})();


/* Set the owner's requested subscription-first default on initial page load.
   A valid ?selling_plan=ID link can preselect a particular delivery interval. */
(function(){
  function selectDefault(){
    const params=new URLSearchParams(window.location.search);
    const preferred=params.get('selling_plan');
    document.querySelectorAll('[data-hf-subscription]').forEach(function(root){
      const subRadio=root.querySelector('input[value="subscribe"]');
      if(!subRadio)return;
      if(preferred){
        root.querySelectorAll('input[name^="hf_frequency_"]').forEach(function(option){
          if(option.value===preferred)option.checked=true;
        });
      }
      subRadio.checked=true;
      subRadio.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',selectDefault,{once:true});
  else selectDefault();
})();
